import React, { Component } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import themeLarge from "../../component/ThemeLarge";

class VitalsLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMetric: "LCP",
      thresholds: {
        LCP: [2500, 4000],
        FID: [100, 300],
        INP: [200, 500],
        CLS: [0.1, 0.25],
        TTFB: [600, 1200],
        FCP: [1800, 3000],
      },
    };
  }

  formatChartData = () => {
    const { groupedMetrics } = this.props;
    const { selectedMetric } = this.state;

    const entries = groupedMetrics[selectedMetric] || [];

    return entries
      .map((entry) => ({
        value: Number(entry.value || 0),
        time: entry.timestamp
          ? entry.timestamp.toDate().toLocaleString("en-GB", {
              day: "2-digit",
              month: "short",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })
          : "—",
      }))
      .reverse(); // oldest to newest
  };

  handleMetricChange = (e) => {
    this.setState({ selectedMetric: e.target.value });
  };

  render() {
    const chartData = this.formatChartData();
    const { selectedMetric, thresholds } = this.state;

    return (
      <div className="mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 style={{ color: themeLarge.colors.primary }}>
            {selectedMetric} Over Time
          </h5>
          <select
            value={selectedMetric}
            onChange={this.handleMetricChange}
            className="form-select form-select-sm"
            style={{ width: "160px" }}
          >
            {Object.keys(this.props.groupedMetrics).map((metric) => (
              <option key={metric} value={metric}>
                {metric}
              </option>
            ))}
          </select>
        </div>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="time" minTickGap={20} />
            <YAxis />
            <Tooltip />

            {/* Threshold Lines */}
            <ReferenceLine
              y={thresholds[selectedMetric][0]}
              stroke="#2e7d32"
              strokeDasharray="3 3"
              label={{
                value: "Good",
                position: "insideTopRight",
                fill: "#2e7d32",
                fontSize: 12,
              }}
            />
            <ReferenceLine
              y={thresholds[selectedMetric][1]}
              stroke="#f9a825"
              strokeDasharray="3 3"
              label={{
                value: "Needs Improvement",
                position: "insideTopRight",
                fill: "#f9a825",
                fontSize: 12,
              }}
            />

            <Line
              type="monotone"
              dataKey="value"
              stroke={themeLarge.colors.primary}
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default VitalsLineChart;
